import { takeEvery, fork, put, all, call, takeLatest } from "redux-saga/effects";

// Login Redux States
import { Profile2ActionTypes, setCurrentUserDone, clearCurrentUserDone } from "./p2_reducer"
import { ProfileActionTypes } from "../profile/types";
import { logoutCurrentUser } from "api";
import { getCurrentUser as getCurrentUserApi } from "../../api/auth";
import {
    updateReadMsg as updateReadMsgApi,
    delGroupFromUser as delGroupFromUserApi,
    applyUserToGroup as applyUserToGroupApi,
    findMemberToGroup as findMemberToGroupApi,
    findDConnectWebUser as findDConnectWebUserApi,
    findDConnectCusForMatch as findDConnectCusForMatchApi,
    findErpSupForMatch as findErpSupForMatchApi,
    getWebUserId as getWebUserIdApi,
    ucChatAlighRight as ucChatAlighRightApi

} from "../../api/chats"
import { chatsApiResponseError, chatsApiResponseSuccess, getChatRoomLists, updateSenderInfo } from "../chats/actions";
import { profileApiResponseSuccess } from "../profile/actions";
import { setActiveWebUserId } from "../profile2/p2_reducer";

import BasicDetails from "pages/Dashboard/UserProfileDetails/BasicDetails";
import { CurUser, Utils } from "helpers/utils";
import { ThirdApi } from "api/apiThird";
import { sp_GetWebUserId } from "types";


// function* getProfileDetails() {
//     try {
//         const response: Promise<any> = yield call(getProfileDetailsApi);
//         yield put(
//             profileApiResponseSuccess(
//                 ProfileActionTypes.GET_PROFILE_DETAILS,
//                 response
//             )
//         );
//     } catch (error: any) {
//         yield put(
//             profileApiResponseError(ProfileActionTypes.GET_PROFILE_DETAILS, error)
//         );
//     }
// }

function* setUserDetails({ payload: { data } }: any) {
    // console.log('p2_saga setUserDetails', data);
    try {
        // const response: Promise<any> = yield call(getProfileDetailsApi);
        // const myData = {
        //     uid: data.userId,
        //     username: data.nickName,
        //     role: data.userType,
        //     // password: ,
        //     // email: "",
        //     profileImage: "",
        // };
        // localStorage.setItem("authUser", JSON.stringify(data));
        CurUser.SaveToLocal(JSON.stringify(data), null);
        // console.log('setCurrentUserDone:', data);
        yield put(setCurrentUserDone(data));
    } catch (error: any) {
        console.error(error);
        // yield put(
        //     profileApiResponseError(ProfileActionTypes.GET_PROFILE_DETAILS, error)
        // );
    }
}

function* updateReadMsg({ payload: { userGroupId, msgIds } }: any) {
    try {
        // console.log('update read msg:', { userGroupId, msgIds });
        // const x = new Set();
        // x.add('1');
        // x.add('2');
        // x.add('3');
        // const parm = Array.from(x);
        //console.log('function* updateReadMsg:' , msgIds);
        if (msgIds && msgIds.length > 0) {
            //console.log('function* updateReadMsg: ' + msgIds.length + " msg");
            // console.log('function* updateReadMsg:' , msgIds);
            const response: Promise<void> = yield call(updateReadMsgApi, userGroupId, msgIds);
        }
    } catch (error: any) {
        console.error(error);
    }
}

function* clearUserDetails({ payload: { callFrom, reason } }: any) {
    try {
        yield call(logoutCurrentUser);
    } catch (error: any) {
        console.error(error);
        // yield put(
        //     profileApiResponseError(ProfileActionTypes.GET_PROFILE_DETAILS, error)
        // );
    }
    // localStorage.removeItem("authUser");
    // Utils.JwtTokenSet(null);
    yield call(CurUser.ClearFromLocal, callFrom, reason);

    yield put(clearCurrentUserDone());
}

function* getCurrentUser() {
    try {
        // console.log('function* getCurrentUser()');
        const response: Promise<any> = yield call(getCurrentUserApi);
        //console.log('function* getCurrentUser():', response);
        const rp2 = response as any;
        if (rp2.success) {
            yield put(chatsApiResponseSuccess(Profile2ActionTypes.GET_CURRENT_USER, response));
            const profileDetails = {
                basicDetails: Utils.Profile2ToProfileBasicDetail(rp2.data)
            }
            yield put(profileApiResponseSuccess(ProfileActionTypes.GET_PROFILE_DETAILS, profileDetails));
            yield put(updateSenderInfo(rp2.data.userId, rp2.data.pictureUrl));
            /*
            localStorage.setItem("authUser", JSON.stringify(rp2.data));
            if (rp2.data.isViewAs == false) { // 20250716 (If view as, server not return token, then no need to set bellow data because its will set to blank and seem no login)
                Utils.JwtTokenSet(rp2.tag);
            }*/
            CurUser.SaveToLocal(JSON.stringify(rp2.data), rp2.data.isViewAs == false ? rp2.tag : null);
        } else {
            console.error(rp2.message);

            // localStorage.removeItem("authUser");
            // Utils.JwtTokenSet(null);
            yield call(CurUser.ClearFromLocal, "GetCurrentUserSaga(1)", "Call API and get error: " + rp2.message); 
        }
        // console.log('xx:',(response as any).data);
        // console.log('function* getCurrentUser():', response);
        // yield put(profileApiResponseSuccess(ProfileActionTypes.GET_PROFILE_DETAILS, (response as any).data));
    } catch (error: any) {
        console.error(error);
        // localStorage.removeItem("authUser");
        // Utils.JwtTokenSet(null);
        // yield call(CurUser.ClearFromLocal,"GetCurrentUserSaga(2)", "Call API and get error: " + Utils.GetMessageFromExecption(error));  // 20251118 temporary not remove from local to prevent re-login often
        yield put(chatsApiResponseError(Profile2ActionTypes.GET_CURRENT_USER, error));
    }
}

function* delGroupFromUser({ payload: { groupId, memberId } }: any) {
    try {
        // console.log('saga delUserFromGroup:',{ groupId, memberId });
        const response: Promise<any> = yield call(delGroupFromUserApi, groupId, memberId);
        // console.log('response:', response);
        yield put(
            chatsApiResponseSuccess(Profile2ActionTypes.DEL_GROUP_FROM_USER, response)
        );
        // #DEFINE WAIT NEW VERSION yield put(getChatRoomLists());
    } catch (error: any) {
        yield put(
            chatsApiResponseError(Profile2ActionTypes.DEL_GROUP_FROM_USER, error)
        );
    }
}

function* applyUserToGroup({ payload: { memberId, inviteCode } }: any) {
    try {
        // console.log('saga delUserFromGroup:',{ groupId, memberId });
        const response: Promise<any> = yield call(applyUserToGroupApi, memberId, inviteCode);
        // console.log('response:', response);
        yield put(
            chatsApiResponseSuccess(Profile2ActionTypes.APPLY_USER_TO_GROUP, response)
        );
    } catch (error: any) {
        yield put(
            chatsApiResponseError(Profile2ActionTypes.APPLY_USER_TO_GROUP, error)
        );
    }
}

export function* setActiveGroupId({ payload: activeGroupId }: any) {
    try {
        // const webUserId: Promise<any> = yield call(getWebUserIdApi, activeGroupId);
        // console.log('webUserId:', webUserId);
        const resp: sp_GetWebUserId = yield call(getWebUserIdApi, activeGroupId);
        // console.log('resp:', resp);


        // console.log('setActiveGroupId to ' + activeGroupId + ' got result:', resp);
        // console.log('setActiveWebUserId = ' + 'webUserId = ' +  resp.webUserId + ', customerIsCdSys = ' + resp.customerIsCdSys);
        yield put(
            //setActiveWebUserId(webUserId)
            setActiveWebUserId(resp.webUserId, resp.customerIsCdSys)
        );

        // Register the web user ID (handle async explicitly)
        yield call([new ThirdApi(), 'DConnect_RegisterWebUserId'], resp.customerIsCdSys, resp.webUserId);

    } catch (error: any) {
        yield put(
            setActiveWebUserId(null, 0)
        );
    }
}


function* findMemberToGroup({ payload: { currentGroupId, filters, filterUserType } }: any) {
    try {
        // console.log('findMemberToGroup.filters:', { currentGroupId, filters, filterUserType });
        if (filters == '') {
            //console.log('no parameter');
        }
        const response: Promise<any> = yield call(findMemberToGroupApi, currentGroupId, filters, filterUserType);
        if (filters == '') {
            //console.log('no parameter - done');
        }

        // console.log('findMemberToGroup.response:', response);
        yield put(
            //chatsApiResponseSuccess(Profile2ActionTypes.FIND_MEMBER_TO_GROUP, response)
            chatsApiResponseSuccess(Profile2ActionTypes.FIND_MEMBER_TO_GROUP, { filterUserType, response })
        );
    } catch (error: any) {
        yield put(
            chatsApiResponseError(Profile2ActionTypes.FIND_MEMBER_TO_GROUP, error)
        );
    }
}

function* findDconnectWebUser({ payload: { groupChatId, filters } }: any) {
    try {
        //console.log('findDconnectWebUser.filters:', filters);
        if (filters == '') {
            //console.log('no parameter');
        }
        const response: Promise<any> = yield call(findDConnectWebUserApi, groupChatId, filters);
        if (filters == '') {
            //console.log('no parameter - done');
        }

        // console.log('findDconnectWebUser:', response);
        yield put(
            chatsApiResponseSuccess(Profile2ActionTypes.FIND_DCONNECT_WEB_USER, response)
        );
    } catch (error: any) {
        yield put(
            chatsApiResponseError(Profile2ActionTypes.FIND_DCONNECT_WEB_USER, error)
        );
    }
}

function* findDConnectCusForMatch({ payload: { customerCode, customerName } }: any) {
    try {
        //console.log('findDConnectCusForMatch.filters:', filters);
        // if (filters == '') {
        //     //console.log('no parameter');
        // }
        const response: Promise<any> = yield call(findDConnectCusForMatchApi, customerCode, customerName);
        // if (filters == '') {
        //     //console.log('no parameter - done');
        // }

        // console.log('response:', response);
        yield put(
            chatsApiResponseSuccess(Profile2ActionTypes.FIND_DCONNECT_CUS_FORMATCH, response)
        );
    } catch (error: any) {
        yield put(
            chatsApiResponseError(Profile2ActionTypes.FIND_DCONNECT_CUS_FORMATCH, error)
        );
    }
}

function* findEprSupFormatch({ payload: { supplierCode, supplierName } }: any) {
    try {
        const response: Promise<any> = yield call(findErpSupForMatchApi, supplierCode, supplierName);
        yield put(
            chatsApiResponseSuccess(Profile2ActionTypes.FIND_EPR_SUP_FORMATCH, response)
        );
    } catch (error: any) {
        yield put(
            chatsApiResponseError(Profile2ActionTypes.FIND_EPR_SUP_FORMATCH, error)
        );
    }
}

function* ucChatAlighRight({ payload: { chatAlighRight } }: any) {
    try {
        yield call(ucChatAlighRightApi, chatAlighRight);
    } catch (e) {
        console.error(e);
    }
}

export function* watchSetUserDetails() {
    yield takeLatest(Profile2ActionTypes.SET_USER, setUserDetails);
}

export function* watchClearUserDetails() {
    yield takeLatest(Profile2ActionTypes.CLEAR_USER, clearUserDetails);
}

export function* watchUpdateReadMsg() {
    yield takeEvery(Profile2ActionTypes.UPDATE_READ_MSG, updateReadMsg);
}

export function* watchGetCurrentUser() {
    yield takeLatest(Profile2ActionTypes.GET_CURRENT_USER, getCurrentUser);
}

export function* watchDelGroupFromUser() {
    yield takeEvery(Profile2ActionTypes.DEL_GROUP_FROM_USER, delGroupFromUser);
}

export function* watchApplyUserToGroup() {
    yield takeEvery(Profile2ActionTypes.APPLY_USER_TO_GROUP, applyUserToGroup);
}

export function* watchFindMemberToGroup() {
    yield takeLatest(Profile2ActionTypes.FIND_MEMBER_TO_GROUP, findMemberToGroup);
}

export function* watchFindDconnectWebUser() {
    yield takeLatest(Profile2ActionTypes.FIND_DCONNECT_WEB_USER, findDconnectWebUser);
}

export function* watchfindDConnectCusForMatch() {
    yield takeLatest(Profile2ActionTypes.FIND_DCONNECT_CUS_FORMATCH, findDConnectCusForMatch);
}

export function* watchfindEprSupFormatch() {
    yield takeLatest(Profile2ActionTypes.FIND_EPR_SUP_FORMATCH, findEprSupFormatch);
}

export function* watchSetActiveGroupId() {
    yield takeLatest(Profile2ActionTypes.SET_ACTIVE_GROUP_ID, setActiveGroupId);
}

export function* watchUcChatAlighRight() {
    yield takeLatest(Profile2ActionTypes.UC_CHAT_ALIGH_RIGHT, ucChatAlighRight);
}

function* profile2Saga() {
    yield all([
        fork(watchSetUserDetails),
        fork(watchClearUserDetails),
        fork(watchGetCurrentUser),
        fork(watchUpdateReadMsg),
        fork(watchDelGroupFromUser),
        fork(watchApplyUserToGroup),
        fork(watchFindMemberToGroup),
        fork(watchFindDconnectWebUser),
        fork(watchfindDConnectCusForMatch),
        fork(watchfindEprSupFormatch),
        fork(watchSetActiveGroupId),
        fork(watchUcChatAlighRight),
    ]);
    // yield takeLatest(Profile2ActionTypes.SET_USER, setUserDetails);
}

export default profile2Saga;
